import { useLocation, useParams } from 'react-router-dom';
import { RoutePaths } from '../../routes/RoutePaths';
import {
    StyledCandidatesPageWrap,
    StyledTableContainer,
} from './JobApplicationsPage.styles';
import { JobApplicationsTable } from '../../components/Tables';
import JobApplicationEntity from '../../components/JobApplicationEntity';
import BulkRejectApplicationModal from '../../components/JobApplicationEntity/BulkRejectApplicationModal';
import TransferCandidateModal from '../../components/JobApplicationEntity/TransferCandidateModal';
import { Typography } from '../../base';
import { useTranslation } from 'react-i18next';

const SavedForLaterPage = () => {
    const location = useLocation();
    const { id } = useParams();
    const path = location.pathname;
    const isEntityPath = path?.replace(/\/+$/, '') !== RoutePaths.savedForLater;
    const { t } = useTranslation();
    return (
        <>
            {isEntityPath && <JobApplicationEntity applicationId={id || '0'} />}
            <StyledCandidatesPageWrap isEntityPath={isEntityPath}>
                <Typography variant="h3" color="secondary">
                    {t('savedForLaterPage.savedCandidatesTitle')}
                </Typography>
                <StyledTableContainer>
                    <JobApplicationsTable isSavedForLater />
                </StyledTableContainer>
            </StyledCandidatesPageWrap>
            <BulkRejectApplicationModal />
            <TransferCandidateModal />
        </>
    );
};

export default SavedForLaterPage;
